var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLocation = function SvgLocation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 3.33464C11.6077 3.33464 14.166 4.5013 14.166 7.6263C14.166 9.4263 12.7327 11.518 9.99935 13.7263C7.26602 11.518 5.83268 9.41797 5.83268 7.6263C5.83268 4.5013 8.39102 3.33464 9.99935 3.33464ZM9.99935 1.66797C7.27435 1.66797 4.16602 3.71797 4.16602 7.6263C4.16602 10.2263 6.10768 12.968 9.99935 15.8346C13.891 12.968 15.8327 10.2263 15.8327 7.6263C15.8327 3.71797 12.7243 1.66797 9.99935 1.66797Z",
    fill: "#777776"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 5.83203C9.08268 5.83203 8.33268 6.58203 8.33268 7.4987C8.33268 8.41536 9.08268 9.16536 9.99935 9.16536C10.4414 9.16536 10.8653 8.98977 11.1779 8.67721C11.4904 8.36465 11.666 7.94073 11.666 7.4987C11.666 7.05667 11.4904 6.63275 11.1779 6.32019C10.8653 6.00763 10.4414 5.83203 9.99935 5.83203ZM4.16602 16.6654H15.8327V18.332H4.16602V16.6654Z",
    fill: "#777776"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLocation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/location.15b5b208.svg";
export { ForwardRef as ReactComponent };